/** The web Start onboarding's steps (cloud/API.md, Funnel counts). Counts only: nothing else is sent. */
export type FunnelEvent = 'try_opened' | 'start_opened' | 'map_filled' | 'reveal_seen' | 'keep_clicked' | 'paid';

const STORAGE_PREFIX = 'mm.funnel.';
const countedThisPage = new Set<FunnelEvent>();

/** Whether this tab has not counted `event` yet; marks it counted. Without storage, once per page load. */
function firstTime(event: FunnelEvent): boolean {
  if (countedThisPage.has(event)) return false;
  countedThisPage.add(event);
  try {
    if (sessionStorage.getItem(STORAGE_PREFIX + event)) return false;
    sessionStorage.setItem(STORAGE_PREFIX + event, '1');
  } catch {
    /* storage may be unavailable */
  }
  return true;
}

/** Counts one funnel step, at most once per tab session. Never throws, never sends a cookie. */
export function countOnce(event: FunnelEvent): void {
  try {
    if (!firstTime(event)) return;
    void fetch('/api/public/funnel', {
      method: 'POST',
      credentials: 'omit',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event }),
    }).catch(() => {});
  } catch {
    /* counting must never break the page */
  }
}
